import React, { useState, useEffect } from 'react';
import MasterPage from 'components/MasterPage';
import { useTranslation } from 'react-i18next';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import { AccountCircleOutlined } from '@material-ui/icons';
import FormControl from 'helpers/FormControl';
import { api } from 'services';
import Input from 'helpers/Input';

const Account = () => {
	const id = JSON.parse(localStorage.getItem('user')).id

	const [user, setUser] = useState({});
	const [languages, setLanguages] = useState([]);
	const [language, setLanguage] = useState('');
	const [errors, setErrors] = useState([]);
	const [firstname, setFirstname] = useState('');
	const [lastname, setLastname] = useState('');
	const [email, setEmail] = useState('');
	const [phone, setPhone] = useState('');
	const [alias, setAlias] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		api.get('languages').then(({ data }) => setLanguages(data));

		if (id) {
			api.get(`users/${id}`).then(({ data }) => {
				setFirstname(data.firstname);
				setLastname(data.lastname);
				setEmail(data.email);
				setPhone(data.phone ? data.phone : '');
				setAlias(data.alias ? data.alias : '');
				setLanguage(data.language_id);
			});
		}
	}, [])

	const handleError = errors => setErrors(errors);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsLoading(true);
		const data = {
			firstname,
			lastname,
			email,
			phone,
			alias,
			language
		}

		await api.put(`/users/${id}`, data, {
			headers: {
				'X-Success-Message': 'Dados atualizados com sucesso',
				'X-Show-Alert': true
			}
		})
			.then(response => {
				localStorage.setItem('user', JSON.stringify(response.data));
			})
			.finally(() => setIsLoading(false));
	}

	const { t } = useTranslation();
	return (
		<>
			<Row>
				<Col className="d-flex mt-3 mb-3">
					<AccountCircleOutlined className="icon-title" />
					<h4 className="title-dashboard mt-2">{t('title:account')}</h4>
				</Col>
			</Row>
			<Card.Body className="shadow bg-white rounded mb-3">
				<Form onSubmit={handleSubmit}>
					<Row>
						<Col md="4">
							<Form.Group>
								<Form.Label>{t('label:firstname')}</Form.Label>
								<FormControl
									validation={errors.firstname}
									onChange={e => setFirstname(e.target.value)}
									value={firstname}
									required
								/>
							</Form.Group>
						</Col>
						<Col md="4">
							<Form.Group>
								<Form.Label>{t('label:lastname')}</Form.Label>
								<FormControl
									value={lastname}
									onChange={e => setLastname(e.target.value)}
									validation={errors.lastname}
									required
								/>
							</Form.Group>
						</Col>
						<Col md="4">
							<Form.Group>
								<Form.Label>{t('label:email')}</Form.Label>
								<FormControl
									disabled
									type="email"
									value={email}
									onChange={e => setEmail(e.target.value)}
									validation={errors.email}
									required
								/>
							</Form.Group>
						</Col>
						<Col md="4">
							<Form.Group>
								<Form.Label>{t('label:phone')}</Form.Label>
								<Input.Phone
									value={phone}
									onChange={e => setPhone(e.target.value)}
									validation={errors.phone}
								/>
							</Form.Group>
						</Col>
						<Col md="4">
							<Form.Group>
								<Form.Label>{t('label:alias')}</Form.Label>
								<FormControl
									value={alias}
									onChange={e => setAlias(e.target.value)}
									validation={errors.alias}
								/>
							</Form.Group>
						</Col>
						<Col md="4">
							<Form.Group>
								<Form.Label>{t('label:language')}</Form.Label>
								<FormControl
									as="select"
									value={language}
									onChange={e => setLanguage(e.target.value)}
									required
								>
									<option disabled={true} value="">
										{t('label:select')}
									</option>
									{languages.map((lang, k) => (
										<option key={k} value={lang.id}>
											{lang.name}
										</option>
									))}
								</FormControl>
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<Button variant="dark" type="submit" className="ml-3" disabled={isLoading}>
							{t('label:save')}
						</Button>
					</Row>
				</Form>
			</Card.Body>
		</>
	)
}

export default MasterPage(Account);